export const GET_ORGANIZATION_ATTENDANCE = 'GET_ORGANIZATION_ATTENDANCE'
export const GET_ORGANIZATION_ATTENDANCE_BY_PUPIL =
  'GET_ORGANIZATION_ATTENDANCE_BY_PUPIL'

export const CLEAR_ORGANIZATION_ATTENDANCE_EMPLOYEE =
  'CLEAR_ORGANIZATION_ATTENDANCE_EMPLOYEE'
export const CLEAR_ORGANIZATION_ATTENDANCE_PUPIL =
  'CLEAR_ORGANIZATION_ATTENDANCE_PUPIL'
